import React from 'react';
import { TagContext } from 'tags/context/tagContext';
import { CARD_TYPE } from 'tags/models/schemas';
import {
  assignTagsToSim,
  createSimTag,
  fetchAssignedTagToSim,
  fetchSimTag,
  fetchSimTags,
} from 'simInventory/Tags/services/tagsSimApi';

type TagProviderProps = {
  children: React.ReactNode;
};

const SIM_PROFILE_TAGS_CONTENT_API = {
  assignTags: assignTagsToSim,
  createTag: createSimTag,
  fetchTag: fetchSimTag,
  fetchTags: fetchSimTags,
  fetchAssignedTags: fetchAssignedTagToSim,
  type: CARD_TYPE.SIM,
  isProduct: false,
};

export const SimProfileTagProvider = ({ children }: TagProviderProps) => {
  return <TagContext.Provider value={SIM_PROFILE_TAGS_CONTENT_API}>{children}</TagContext.Provider>;
};
